interface SignatureBlockProps {
  labels: Array<{ label: string; subtitle?: string }>
}

export default function SignatureBlock({ labels }: SignatureBlockProps) {
  return (
    <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
      {labels.map((item) => (
        <div key={item.label} className="min-h-20 rounded border border-slate-300 px-3 py-3">
          <div className="mt-8 border-t border-slate-900 pt-2 text-sm font-medium text-slate-900">{item.label}</div>
          {item.subtitle && <div className="mt-1 text-xs text-slate-500">{item.subtitle}</div>}
        </div>
      ))}
    </div>
  )
}
